import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import DashboardPage from './pages/dashboard_page';
import { AdminLogin, Platform } from 'keycloakauthmodule';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin platform={Platform.BOXCHAOS} />} />
      <Route path="/dashboard/*" element={localStorage.getItem('token') != null ? <DashboardPage /> : <Navigate to="/login" />} />
      <Route path="/" element={localStorage.getItem('token') != null ? <Navigate to="/dashboard/items" /> : <Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRouter;
